import { useEffect, useState } from 'react'

const getVisualHeight = () =>
  window.visualViewport?.height ?? window.innerHeight

const useVisualViewPort = () => {
  const [viewPortHeight, setHeight] = useState(getVisualHeight())

  const handleResize = () => {
    setHeight(getVisualHeight())
  }

  useEffect(() => {
    window.visualViewport?.addEventListener('resize', handleResize)

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize)
    }
  }, [])

  return [viewPortHeight] as const
}

export default useVisualViewPort
